export const UNLOCK_MODAL_TITLE = 'Choose below to continue citing'
export const YOU_HAVE_HIT_YOUR_CITATION_LIMIT = 'You have hit your citation limit.'

export const SPONSORED_CTA_TEXT = 'View a sponsored message'
export const CREATE_A_FREE_ACCOUNT = 'Create a free account'
export const SPONSORED_CTA_TAG_TEXT = 'free'
export const SUBSCRIBE_CTA_TEXT = (price = '$9.95') => `Subscribe for ${price} / month`
export const TRY_IT_FOR_TODAY_CTA_TEXT = `Try it for free today`

export const UCF_UNLOCK_MODAL_ID = '--ucf-unlock-modal'

export const FOOTER_BANNER_TEXT = 'Already have an account?'
export const FOOTER_BANNER_CTA_TEXT = 'Sign in'

export const UNLOCK_AD_MODAL_SUBHEADING = 'Subscribe and get rid of ads'
export const UNLIMITED_CITATIONS = 'Create a free account to make unlimited citations.'
